<template>
    <ToolButton :Editor="Editor" KnownIcon="Table" @ToolClick="Editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()">

    </ToolButton>
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

    export default({
        components:{
            ToolButton
        },
        props:["Editor"]
    });
</script>